import { render, staticRenderFns } from "./RecepcionEtiquetaModalComponent.vue?vue&type=template&id=1d44154a&"
import script from "./RecepcionEtiquetaModalComponent.vue?vue&type=script&lang=js&"
export * from "./RecepcionEtiquetaModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports